import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

const data = [
  { rango: "De 1% a 35%", nivel: "corresponde a Nivel Básico" },
  { rango: "De 36% a 55%", nivel: "corresponde a Nivel Intermedio" },
  { rango: "De 56% a 75%", nivel: "corresponde a Nivel Intermedio Alto" },
  {
    rango: "De 76% a 100%",
    nivel: "corresponde a Curso de preparación del TOEFL iBT",
  },
];

const areasValoracion = ["Escritura", "Lectura", "Audición", "Conversación"];

const Tabla = () => {
  return (
    <TableContainer component={Paper}>
      <Typography
        variant="h6"
        align="center"
        sx={{ p: 2, background: "#009999", color: "#fff" }}
      >
        <b>*** Escala de porcentajes del examen TOEFL iBT:</b>
      </Typography>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              <b>RANGO</b>
            </TableCell>
            <TableCell align="center">
              <b>NIVEL</b>
            </TableCell>
            <TableCell align="center">
              <b>ÁREAS DE VALORACIÓN</b>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell align="center">{row.rango}</TableCell>
              <TableCell align="center">{row.nivel}</TableCell>
              <TableCell align="center">{areasValoracion.join(", ")}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Tabla;
